import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90f9c3de"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "p-title",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_2 = { class: "p-title-actions" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "prop-hiearchy" }
const _hoisted_6 = { class: "prop-section-title" }
const _hoisted_7 = { style: {"display":"flex","gap":"10px","flex-wrap":"wrap"} }
const _hoisted_8 = { style: {"white-space":"nowrap"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-plus" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "prop-hiearchy" }
const _hoisted_12 = { class: "prop-section-title" }
const _hoisted_13 = { style: {"display":"flex","gap":"10px","flex-wrap":"wrap"} }
const _hoisted_14 = { style: {"white-space":"nowrap"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-plus" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_GradientImage = _resolveComponent("GradientImage")!
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!
  const _component_GradientEditor = _resolveComponent("GradientEditor")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$t("ssa.displayPane.colorGeneral.editGradients")) + " ", 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_imdex_btn, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel'))),
          mini: "",
          text: "",
          secondary: ""
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      true
        ? (_openBlock(), _createBlock(_component_imdex_text_field, {
            key: 0,
            text: "text",
            small: "",
            label: _ctx.$t(`ssa.displayPane.colorGeneral.searchInputLabel`),
            value: _ctx.searchTerm,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
            leadingIcon: "fal fa-search"
          }, null, 8, ["label", "value"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("ssa.displayPane.colorGeneral.continuous")), 1),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.continuousFiltered, (item, i) => {
            return (_openBlock(), _createBlock(_component_imdex_tooltip, {
              nudgeY: -10,
              key: i
            }, {
              activator: _withCtx((on) => [
                _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "p-hierarchy-item" }), [
                  _createVNode(_component_GradientImage, {
                    active: 
										_ctx.activeGradient != null
											? _ctx.activeGradient.id == item.id
											: false
									,
                    onClick: ($event: any) => (_ctx.activeGradient = item),
                    rgbPoints: item.rgbPoints,
                    size: [30, 30]
                  }, null, 8, ["active", "onClick", "rgbPoints"])
                ], 16)
              ]),
              tooltip: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(item.text), 1)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          (!_ctx.isANewGradient)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.newGradient && _ctx.newGradient(...args))),
                class: "add-gradient-btn"
              }, _hoisted_10))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("ssa.displayPane.colorGeneral.continuousFixed")), 1),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.continuousFixedFiltered, (item, i) => {
            return (_openBlock(), _createBlock(_component_imdex_tooltip, {
              nudgeY: -10,
              key: i
            }, {
              activator: _withCtx((on) => [
                _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "p-hierarchy-item" }), [
                  _createVNode(_component_GradientImage, {
                    active: 
										_ctx.activeGradient != null
											? _ctx.activeGradient.id == item.id
											: false
									,
                    onClick: ($event: any) => (_ctx.activeGradient = item),
                    rgbPoints: item.rgbPoints,
                    size: [30, 30]
                  }, null, 8, ["active", "onClick", "rgbPoints"])
                ], 16)
              ]),
              tooltip: _withCtx(() => [
                _createElementVNode("span", _hoisted_14, _toDisplayString(item.text), 1)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          (!_ctx.isANewGradient)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.newFixedGradient && _ctx.newFixedGradient(...args))),
                class: "add-gradient-btn"
              }, _hoisted_16))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.activeGradient != null)
        ? (_openBlock(), _createBlock(_component_GradientEditor, {
            key: 1,
            onSaved: _cache[4] || (_cache[4] = ($event: any) => {
					(_ctx.continuousLocal = []),
						(_ctx.continuousFixedLocal = []),
						(_ctx.activeGradient = null),
						_ctx.refreshKey++;
					_ctx.$emit('updateColorMap');
				}),
            isFixed: _ctx.activeGradient.type == 'fixed',
            gradientItem: _ctx.activeGradient
          }, null, 8, ["isFixed", "gradientItem"]))
        : _createCommentVNode("", true)
    ])
  ]))
}